import angular from 'angular'

import '../../factory/feature'
import '../../factory/analytics'
import '../../factory/storage'

angular.module("core.application.main").directive("core.application.main.directive.featureFlag", [
    "ngIfDirective",
    "$compile",
    "$timeout",
    "core.application.main.factory.feature",
    "core.application.main.factory.analytics",
    "core.application.main.factory.storage",
    function(ngIfDirective, $compile, $timeout, Feature, Analytics, Storage) {
        // This directive implements "ng-if" behaviour by injecting ng-if as an attribute dynamically
        // based on the feature flag returned by the Launch Darkly factory
        var ngIf = ngIfDirective[0];

        var expose = {
            transclude: ngIf.transclude,
            priority: ngIf.priority,
            terminal: ngIf.terminal,
            restrict: "A",
            scope: {
                flag: "=?",
                featureFlagValue: "=?",
                featureFlagFallback: "=?",
            }
        };

        expose.link = function($scope, element, attributes) {
            $scope.retrieveFlag = function() {
                var featureFlagFallback = $scope.featureFlagFallback || false;
                var featureFlagPromise = Feature.retrieveFeatureFlagPromise(attributes.featureFlag, featureFlagFallback);
                if (featureFlagPromise) {
                    featureFlagPromise.then(function(flag) {
                        if (attributes.featureFlagValue) {
                            // Check if the attribute is truthy/exists, but use the scope value instead.
                            // We can't check if the scope value is truthy/exists, because it might
                            // resolve to false, however false might actually be the desired outcome.
                            // Useful for a condition where we need to show one element and not
                            // another element with a boolean.
                            // Or for multivariate flags passed as strings.
                            $scope.flag = (flag === $scope.featureFlagValue) ? true : false;
                        } else {
                            $scope.flag = flag;
                        }
                        $timeout(function() {
                            // PAYL-9300 Wrap the apply call in a timeout to prevent possible
                            // digest loop errors
                            $scope.$apply();
                        });
                    });
                } else {
                    // This fallback can't handle multivariate string based flags.
                    // For those cases, put a fallback of true on one of the
                    // multivariates and false on all the others.
                    $scope.flag = featureFlagFallback;
                    Analytics.sendAmplitudeEvent("Trigger Feature Flag Fallback");
                }
                if (Storage.setSessionStorageItem("LDClientInitError")) {
                    Analytics.sendAmplitudeEvent("Triggered Fallback by LDClient Init");
                }
                if (Storage.setSessionStorageItem("LDClientResponseError")) {
                    Analytics.sendAmplitudeEvent("Triggered Fallback by LDClient Response");
                }
            };

            $scope.$on("featureFlagsReady", function() {
                // This is needed for a page refresh of the app.
                $scope.retrieveFlag();
            });

            $scope.retrieveFlag();

            attributes.ngIf = function() {
                return $scope.flag;
            };

            ngIf.link.apply(ngIf, arguments);
        };

        return expose;
    }
]);
